module.exports = __webpack_public_path__ + "static/media/harel-logo.a477e5f3.png";